export default __webpack_public_path__ + "static/media/shivanna_daughter.106c9ad2.jpg";